<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("TITLES.showPackage") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #446e80">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form>
        <div class="row">
          <div class="preview-container text-center my-3">
            <img
              v-if="data.image?.path"
              col="12"
              :src="data.image?.path"
              :alt="$t('PLACEHOLDERS.package_image')"
              style="
                max-width: 300px;
                max-height: 300px;
                object-fit: cover;
                border-radius: 8px;
              "
            />
          </div>
          <!-- Start:: Name Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.nameAr')"
            v-model.trim="data.name_ar"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.nameEn')"
            v-model.trim="data.name_en"
            disabled
          />
          <!-- End:: Name Input -->

          <!-- Start:: Duration Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.package_duration')"
            v-model="durationText"
            disabled
          />
          <!-- End:: Duration Input -->

          <!-- Start:: Price Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.package_price')"
            v-model.number="data.price"
            disabled
          />
          <!-- End:: Price Input -->

          <!-- Start:: Number of Subscribers -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('TABLES.Packages.number_of_subscriptions')"
            v-model.number="data.number_of_subscriptions"
            disabled
          />
          <!-- End:: Number of Subscribers -->

          <!-- Start:: Created Date -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('TABLES.Packages.created_at')"
            v-model="data.created_at"
            disabled
          />
          <!-- End:: Created Date -->

          <!-- Start:: Status Switch Input -->
          <div class="input_wrapper switch_wrapper my-5">
            <v-switch
              color="green"
              :label="
                data.is_active == 1
                  ? $t('STATUS.active')
                  : $t('STATUS.notActive')
              "
              v-model="data.is_active"
              hide-details
              disabled
            ></v-switch>
          </div>
          <!-- End:: Status Switch Input -->

          <!-- Start:: View Subscribers Button -->
          <div class="col-12 mb-3" v-if="data.number_of_subscriptions > 0">
            <router-link
              :to="`/packages/subscribers/${data.id}`"
              class="btn btn-primary"
            >
              {{ $t("SIDENAV.Packages.subscribers") }}
            </router-link>
          </div>
          <!-- End:: View Subscribers Button -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
export default {
  name: "ShowPackage",
  data() {
    return {
      isWaitingRequest: false,
      data: {
        id: null,
        name_ar: "",
        name_en: "",
        duration: null,
        price: null,
        number_of_subscriptions: 0,
        is_active: null,
        created_at: null,
        image: {
          path: null,
          file: null,
        },
      },
    };
  },
  computed: {
    durationText() {
      return this.data.duration
        ? `${this.data.duration} ${this.$t("STATUS.months")}`
        : "---";
    },
  },
  methods: {
    // start show data
    async showPackage() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `subscription-packages/${this.$route.params?.id}`,
        });
        const packageData = res.data.data.data;
        this.data.id = packageData.id;
        this.data.name_ar = packageData.name_ar;
        this.data.name_en = packageData.name_en;
        this.data.duration = packageData.duration;
        this.data.price = packageData.price;
        this.data.number_of_subscriptions = packageData.number_of_subscriptions;
        this.data.image.path = packageData.image;
        this.data.is_active = parseInt(packageData.is_active) === 1;
        this.data.created_at = packageData.created_at;
      } catch (error) {
        this.loading = false;
        console.log(error?.response?.data?.message);
      }
    },
    // end show data
  },
  created() {
    this.showPackage();
  },
};
</script>

<style scoped>
.preview-container {
  padding: 20px;
}

.btn-primary {
  background-color: #7c0d89;
  color: white;
  padding: 10px 20px;
  border-radius: 5px;
  text-decoration: none;
  display: inline-block;
  transition: background-color 0.3s;
}

.btn-primary:hover {
  background-color: #5a0a65;
}
</style>
